var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.localMessage)?_c('div',{staticClass:"modal-counter"},[_vm._v(_vm._s(_vm.localMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }